// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"c1f69f02","453":"097b5ed4"}[chunkId] + ".chunk.js";
};